/*
    Author: draplater
    Create Time: 17-8-2
    Project: verbnet2017
*/

import * as React from "react";
import {FrameMeta} from "../problem-domain/frame";
import {MenuItem, Dropdown} from "react-bootstrap";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {GlobalState} from "../reduxSetting";
import {LinkContainer} from "react-router-bootstrap";

const classNames: any = require("classnames");

function splitComponentProps(props, Component) {
    const componentPropTypes = Component.propTypes;

    const parentProps = {};
    const childProps = {};

    (Object as any).entries(props).forEach(([propName, propValue]) => {
        if (componentPropTypes[propName]) {
            parentProps[propName] = propValue;
        } else {
            childProps[propName] = propValue;
        }
    });

    return [parentProps, childProps];
}

namespace FrameDropdownMenu {
    export interface Props {
        frame: FrameMeta,
        path: string[],
        styles?: any,
        className?: any
    }

    export interface State {
        expandWhich: string | null
    }
}

export class FrameDropdownMenu extends React.Component<FrameDropdownMenu.Props,
    FrameDropdownMenu.State> {
    constructor(props) {
        super(props);
        this.state = {expandWhich: null};
    }

    renderSubMenu(sub_frame) {
        return (<li className="dropdown-submenu"
                    onMouseEnter={() => {
                        this.setState({expandWhich: sub_frame.name})
                    }}
        >
            <Link to={"/" + ["frame", ...this.props.path, sub_frame.name].join("/")}
                  className="frame-dropdown-expandable"> {sub_frame.name} </Link>
            <span
                className="frame-dropdown-expander"> {this.state.expandWhich === sub_frame.name ? "▶" : "▷"} </span>
            <FrameDropdownMenu frame={sub_frame}
                               path={[...this.props.path, sub_frame.name]}
                               className={
                                   this.state.expandWhich === sub_frame.name ?
                                       "frame-dropdown-active" : "frame-dropdown"
                               }/>
        </li>);
    }

    renderLeaf(sub_frame) {
        return (<li className="dropdown-item"><Link
                to={"/" + ["frame", ...this.props.path, sub_frame.name].join("/")}>
                {sub_frame.name}
            </Link>
            </li>
        );
    }

    render() {
        return <Dropdown.Menu style={this.props.styles} className={this.props.className}>
            {this.props.frame.sub_frames.map((value) =>
                value.sub_frames.length ? this.renderSubMenu(value) : this.renderLeaf(value)
            )
            }
        </Dropdown.Menu>
    }
}

export const FrameDropdownMenuRedux = (connect as any)(
    (state: GlobalState) => ({
        frame: {
            sub_frames: state.index.frames,
            lexicons: []
        }, path: [], bsRole: "menu"
    }),
    dispatch => ({}))(FrameDropdownMenu);


export class DropdownSimple extends React.Component<{ title: string }, { open: boolean }> {
    private mouseOutTimeout: any = null;

    constructor(props) {
        super(props);
        this.state = {open: false};
    }

    render() {
        return <li className={classNames({open: this.state.open})}
                   onMouseEnter={() => {
                       if (this.mouseOutTimeout !== null) {
                           clearTimeout(this.mouseOutTimeout);
                       }
                       this.setState({open: true});
                   }}
                   onMouseLeave={(e) => {
                       if (this.mouseOutTimeout !== null) {
                           clearTimeout(this.mouseOutTimeout);
                       }
                       this.mouseOutTimeout = setTimeout(
                           () => {
                               this.setState({open: false})
                           }, 500);
                   }}
                   onClick={() => {
                       if (this.mouseOutTimeout !== null) {
                           clearTimeout(this.mouseOutTimeout);
                       }
                       this.setState({open: false})
                   }}>
            <Link to="/frame-index"> {this.props.title} </Link>
            {this.props.children}
        </li>
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/dropdown.tsx